<div class="legal-consents" [formGroup]="form">
  <mat-checkbox
    class="legal-consent white-border-checkbox"
    formControlName="acceptTerms"
  >
    {{ "SIGNUP_ACCEPT_TERMS_PREFIX" | translate }}
    <a
      [href]="cguUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="text-white! underline"
      (click)="$event.stopPropagation()"
      >{{ "SIGNUP_ACCEPT_TERMS_LINK" | translate }}</a
    >.
  </mat-checkbox>

  <mat-checkbox
    class="legal-consent white-border-checkbox"
    formControlName="acceptPrivacy"
  >
    {{ "SIGNUP_ACCEPT_PRIVACY_PREFIX" | translate }}
    <a
      [href]="privacyUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="text-white! underline"
      (click)="$event.stopPropagation()"
      >{{ "SIGNUP_ACCEPT_PRIVACY_LINK" | translate }}</a
    >
    {{ "SIGNUP_ACCEPT_PRIVACY_SUFFIX" | translate }}
  </mat-checkbox>
</div>
